export default {
  main: {
    site_id: 215,
    enableWorldCup: true,
    title: "Terminal PRO",
    enableTouchToClick: true,
    logoSize: "big",
    enableWinterMode: false,
    ticketPayoutExpirationDays: 1000,
    showCustomLockScreenMessages: true,
    homeIdleTimeInMinutes: 5,
    termsAndConditions: true,
    staffPassword: "0",
    //hotjarId: 4933472,
    yandexMetricaId: 96965226,
    websitePasswordHash: "4cf5b7bc9cbd9acb074ba9cfb2b8ef622297588e81a75073887c98df8024b010",
    termsAndConditionsDefaultLanguage: "fra",
    enableHeaderAdminSection: true,
    enableSportListScroll: true,
    enableKeyboardCatching: true,
    enableThemeToggle: true,
    enableTerminalUsageConfirmation: true,
    homeMediaSlides: [
      {
        type: "sport",
        path: "betting/prematch",
      },
    ],
    availableLanguages: {
      "@replace": true,
      dut: {
        short: "NL",
        name: "Ned",
        order: 1,
      },
      fra: {
        short: "FR",
        name: "Fra",
        order: 2,
      },

      eng: {
        short: "en",
        name: "Eng",
        order: 3,
      },
      spa: {
        short: "ES",
        name: "Esp",
        region: "UnitedKingdom",
        order: 4,
      },
      tur: {
        short: "tr",
        name: "Tur",
        order: 5,
      },

      ita: {
        short: "it",
        name: 'Ita',
        order: 6,
      },
    },
  },
  homePagesUrl: [
    {
      id: 1,
      url: 'betting/live',
      icon: 'global-icon icon-circle icon-a',
      className: 'live-section',
      name: 'Live',
    },
    {
      id: 1992,
      url: 'betting/prematch?filterType=todaytoday',
      className: 'prematch-section',
      name: 'Today',
    },
    {
      id: 3,
      url: 'betting/results',
      className: 'results-section',
      name: 'Results',
    },
  ],
  tickets: {
    enableMultipleTickets: false,
  },
  perBetshopLanguages: [
    {
      ids: [117192, 117072, 115756, 116262, 114611, 115741, 115918, 114268, 116119, 116019, 112737, 115932, 115896, 115948, 114805, 112070, 112560, 114984, 110002, 112667, 106351, 106338, 112171, 115725, 116118, 110004, 114971, 116119, 116118, 116147, 116148, 116206, 116180, 116207, 115625, 112446],
      lang: 'dut',
    },
  ],
  env: {
    lang: "fra",
  }, 
  home: {
    grid: [
      ["shortpages", "liveGameBanner"],
      ["slider", "liveGameBanner"],
      ["comp", "liveGameBanner"],
    ],
    gridColumns: "3fr 1fr",
    gridRows: "5fr 24fr 10fr",
    liveGamesCount: 6,
    casinoGamesCount: 6,
    topPagesPaths: ['betting/live', 'betting/prematch', 'betting/results'],
  },
  adminPageButtons: [
    {
      name: "Admin User",
      type: "adminUserSections",
      hideOnRestrictMode: false,
      enabled: true,
    },
    {
      name: "Application and terminal management",
      type: "applicationAndTerminal",
      enabled: true,
    },
    {
      name: "Tickets",
      type: "lastTicket",
      enabled: true,
    },
    {
      name: "Financial tracking",
      type: "financialTracking",
      enabled: true,
      hideOnRestrictMode: false,
    },
    {
      name: "Open last log file",
      type: "openLastLogFile",
      enabled: true,
      hideOnRestrictMode: true,
    },
    {
      name: "Lock",
      type: "lockAndUnlock",
      param: { type: "lock" },
      enabled: true,
    },
    {
      name: "Unlock",
      type: "lockAndUnlock",
      param: { type: "unlock" },
      enabled: true,
    },
    {
      name: "Devices",
      type: "devices",
      enabled: true,
      hideOnRestrictMode: true,
    },
  ],
  applicationAndTerminalButtons: [
    {
      name: "Shut down terminal",
      hideOnRestrictMode: true,
    },
    {
      name: "Close application",
      hideOnRestrictMode: true,
    },
    {
      name: "Reboot PC",
      hideOnRestrictMode: false,
    },
  ],
  lastTicketButtons: [
    {
      name: "Bet tickets",
      type: "betTicket",
      hideOnRestrictMode: false,
    },
    {
      name: "Cash-out",
      type: "cashoutTicket",
      hideOnRestrictMode: false,
    }
  ],
  betslip: {
    bookingBetBalanceMaxLimit: 9999999,
    staticStakes: ["5", "10", "20", "50", "100", "200"],
    enableBookingId: false,
    betDetailsOrder: ["total_odd", "min_possible_win", "possible_win", "total_win"],
  },
  betBuilder: {
    enableTaxOnStake: false,
  },
  depositMethods: [
    {
      type: "hipay",
      enabled: false, // but method will appear if enableOnlinePayment true
      betshopId: 106352, // temporary logic, remove after c# enableOnlinePayment part release
    },
  ],

  defaultTerminalParams: { pid: 215, tid: 7444, token: "p2AOAw==", currency: "EUR" },
    routes: [
      {
      url: 'worldcup',
      name: 'FIFA World Cup',
      enabled: true,
      disableInHeader: true,
    },
    {
      name: 'Betting',
      url: 'betting/prematch/all',
      type: 'sportsBook',
      enabled: true,
      nestedItems: [
        {
          url: 'betting/live/all',
          type: 'live',
          name: 'Live',
          enabled: true,
          icon: 'circle',
        },
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'Sports',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
        {
          type: 'today',
          name: 'Today',
          enabled: false,
          icon: 'boosted-odd',
        },
      ],
    },
    {
          url: 'betting/results',
          name: 'Results',
          type: 'results',
          enabled: true,
          icon: '',
    },
  ],
  sportsbook: {
    enableTwoUP: true,
    disableInHouseBetBuilder: false,
    marketGroupSelectHighlightedMode: true,
    enableBetBuilderIcon: false,
    enableScroll: true,
    enableBoostedOdds: false,
    enablePredefinedMultiples: false,
    competitionList: {
      closeAfterSelect: true,
      showTopCompetitionsListFixed: false,
    },

    timeFilter: {
      enableClassicView: true,
    },

    asianViewMarket: {
      Soccer: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
            {
              display_key: "DOUBLE CHANCE",
              title: "DOUBLE CHANCE",
              side: ["1X", "12", "X2"],
            },
            {
              display_key: "NEXTGOALTOSCORE",
              title: "NEXT GOAL TO SCORE",
              side: ["Home", "No", "Away"],
            },
          ],
          [
            {
              display_key: "BOTHTEAMTOSCORE",
              title: "Both team to score",
              side: ["Yes", "No"],
            },
            {
              display_key: "DRAWNOBET",
              title: "DRAW NO BET",
              side: ["Home", "Away"],
            },
            {
              display_key: "ODD/EVEN",
              market_type: {
                "@in": ["EvenOddTotal", "FirstHalfEvenOddTotal", "SecondHalfEvenOddTotal"],
              },
              title: "Total Goals: Even/Odd",
              side: ["Even", "Odd"],
            },
            {
              display_key: "HANDICAP",
              market_type: {
                "@in": ["AsianHandicap", "HalfTimeAsianHandicap", "2ndHalfAsianHandicap"],
              },
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "CARDSTOTALS",
              title: "Yellow Cards: Total",
              side: ["Over", "Under"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 1.5",
              side: ["Over", "Under"],
              base: 1.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 2.5",
              side: ["Over", "Under"],
              base: 2.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 3.5",
              side: ["Over", "Under"],
              base: 3.5,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
            {
              display_key: "DOUBLE CHANCE",
              title: "DOUBLE CHANCE",
              side: ["1X", "12", "X2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals",
              side: ["Over", "Under"],
              alt_main_order: 1,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 1.5",
              side: ["Over", "Under"],
              base: 1.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 2.5",
              side: ["Over", "Under"],
              base: 2.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 3.5",
              side: ["Over", "Under"],
              base: 3.5,
            },
          ],
          [
            {
              display_key: "BOTHTEAMTOSCORE",
              title: "Both team to score",
              side: ["Yes", "No"],
            },
            {
              display_key: "DRAWNOBET",
              title: "DRAW NO BET",
              side: ["Home", "Away"],
            },
          ],
          [
            {
              display_key: "CORNERTOTALS",
              market_type: "CornersOverUnder",
              title: "Corners: Total",
              side: ["Over", "Under"],
            },
            {
              display_key: "CARDSTOTALS",
              title: "Yellow Cards: Total",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
      Tennis: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
            {
              market_type: "SetHandicap",
              title: "Set Handicap",
              side: ["Home", "Away"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["SetOverUnder", "TotalGamesOver/Under"],
              },
              title: "TOTAL GAMES",
              side: ["Over", "Under"],
            },
            {
              market_type: {
                "@in": ["TotalGamesOddorEven", "SetTotalGamesOddEven"],
              },
              title: "TOTAL GAMES ODD OR EVEN",
              side: ["Even", "Odd"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
            {
              market_type: "SetHandicap",
              title: "Set Handicap",
              side: ["Home", "Away"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["SetOverUnder", "TotalGamesOver/Under"],
              },
              title: "TOTAL GAMES",
              side: ["Over", "Under"],
            },
            {
              market_type: {
                "@in": ["TotalGamesOddorEven", "SetTotalGamesOddEven"],
              },
              title: "TOTAL GAMES ODD OR EVEN",
              side: ["Even", "Odd"],
            },
          ],
        ],
      },
      Basketball: {
        live: [
          [
            {
              title: "Overtime",
              market_type: "Overtime",
              side: ["Yes", "No"],
            },
            {
              display_key: "HANDICAP",
              title: "Match Handicap",
              side: ["Home", "Away"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Match Total",
              side: ["Over", "Under"],
            },
            {
              display_key: "ODD/EVEN",
              title: "Match Total Odd/Even",
              side: ["Even", "Odd"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner 2 Way",
              col_count: 2,
              side: ["P1", "P2"],
            },
          ],
          [
            {
              display_key: "HANDICAP",
              title: "Match Handicap",
              side: ["Home", "Away"],
            },
            {
              display_key: "TOTALS",
              title: "Match Total",
              side: ["Over", "Under"],
            },
            {
              display_key: "ODD/EVEN",
              title: "Match Total Odd/Even",
              side: ["Even", "Odd"],
            },
          ],
        ],
      },
      //     [
      //       {
      //         display_key: "WINNER",
      //         market_type: "MatchWinner3",
      //         title: "Match Result (Regular Time)",
      //         side: ["P1", "X", "P2"],
      //       },
      //       {
      //         display_key: "DOUBLE CHANCE",
      //         title: "Double chance (Regular Time)",
      //         side: ["1X", "12", "X2"],
      //       },
      //     ],
      //     [
      //       {
      //         display_key: "WINNER",
      //         title: "Match Winner (Including Overtime)",
      //         market_type: "MatchWinner2",
      //         side: ["W1", "W2"],
      //       },
      //       {
      //         display_key: "BOTHTEAMTOSCORE",
      //         title: "Both Teams To Score (Regular Time)",
      //         side: ["Yes", "No"],
      //       },
      //       {
      //         market_type: {
      //           "@in": ["MatchTotal2", "PeriodTotal2"],
      //         },
      //         display_key: "TOTALS",
      //         title: "Total (Regular Time)",
      //         side: ["Over", "Under"],
      //       },
      //       {
      //         market_type: {
      //           "@in": ["MatchHandicap2", "PeriodHandicap2"],
      //         },
      //         display_key: "HANDICAP",
      //         title: "Handicap (Regular Time)",
      //         side: ["Home", "Away"],
      //       },
      //     ],
      //   ],
      //   prematch: [
      //     [
      //       {
      //         display_key: "WINNER",
      //         market_type: "MatchWinner3",
      //         title: "Match Result (Regular Time)",
      //         side: ["P1", "X", "P2"],
      //       },
      //       {
      //         display_key: "DOUBLE CHANCE",
      //         title: "Double chance (Regular Time)",
      //         side: ["1X", "12", "X2"],
      //       },
      //     ],
      //     [
      //       {
      //         display_key: "WINNER",
      //         title: "Match Winner (Including Overtime)",
      //         market_type: "MatchWinner2",
      //         side: ["W1", "W2"],
      //       },
      //       {
      //         display_key: "BOTHTEAMTOSCORE",
      //         title: "Both Teams To Score (Regular Time)",
      //         side: ["Yes", "No"],
      //       },
      //       {
      //         market_type: {
      //           "@in": ["MatchTotal2", "PeriodTotal2"],
      //         },
      //         display_key: "TOTALS",
      //         title: "Total (Regular Time)",
      //         side: ["Over", "Under"],
      //       },
      //       {
      //         market_type: {
      //           "@in": ["MatchHandicap2", "PeriodHandicap2"],
      //         },
      //         display_key: "HANDICAP",
      //         title: "Handicap (Regular Time)",
      //         side: ["Home", "Away"],
      //       },
      //     ],
      //   ],
      // },
      Volleyball: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
            {
              market_type: "HANDICAP",
              title: "Match points Handicap",
              side: ["Home", "Away"],
            },
            {
              market_type: "TOTALS",
              title: "Total points",
              side: ["Home", "Away"],
            },
          ],
          [
            {
              market_type: {
                "@in": ["MatchHandicap2", "PeriodHandicap2"],
              },
              display_key: "HANDICAP",
              title: "Handicap (Regular Time)",
              side: ["Home", "Away"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
            {
              market_type: "HANDICAP",
              title: "Match points Handicap",
              side: ["Home", "Away"],
            },
            {
              market_type: "TOTALS",
              title: "Total points",
              side: ["Home", "Away"],
            },
          ],
          [
            {
              market_type: {
                "@in": ["MatchHandicap2", "PeriodHandicap2"],
              },
              display_key: "HANDICAP",
              title: "Handicap (Regular Time)",
              side: ["Home", "Away"],
            },
          ],
        ],
      },
      Pesapallo: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              col_count: 3,
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
      Handball: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              col_count: 3,
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "WINNER",
              title: "Match Result",
              col_count: 2,
              side: ["P1", "P2"],
            },
          ],
        ],
      },
      BallHockey: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Match Result",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Match Result",
              col_count: 3,
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
      Futsal: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              col_count: 3,
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "WINNER",
              title: "Match Result",
              col_count: 2,
              side: ["P1", "P2"],
            },
          ],
        ],
      },
      RugbyLeague: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              col_count: 3,
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "WINNER",
              title: "Match Result",
              col_count: 2,
              side: ["P1", "P2"],
            },
          ],
        ],
      },
      RugbyUnion: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              col_count: 3,
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "WINNER",
              title: "Match Result",
              col_count: 2,
              side: ["P1", "P2"],
            },
          ],
        ],
      },
      WaterPolo: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              col_count: 3,
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
            },
          ],
        ],
      },
      Darts: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              col_count: 2,
              side: ["P1", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: "TotalSetsOver/Under",
              title: "TOTAL SETS",
              side: ["Over", "Under"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              col_count: 2,
              side: ["P1", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: "TotalSetsOver/Under",
              title: "TOTAL SETS",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
      Chess: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              col_count: 3,
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
      default: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              // col_count: 2,
              side: ["P1", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              col_count: 2,
              side: ["P1", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
    },
  },
};
